import React, { useState ,useEffect } from 'react'
import AdminNavbar from '../Navbar/AdminNavbar'
import UserNavbar from '../Navbar/UserNavbar'
import { AiFillFileExcel, AiFillFilePdf, AiOutlineFileText } from 'react-icons/ai'
import axios from 'axios'
import { toast } from 'react-toastify';
import { Button, DatePicker, Input, Select, Table ,Checkbox, Tooltip, Spin} from 'antd';
import dayjs from 'dayjs';
import { Option } from 'antd/es/mentions';
import { AllDailySaleSummary, DailySaleSummary, DailySaleSummaryReport, MineMasterFindAll } from '../Api/All_Api'
import { MineMasterAssignedFindAll, MineMasterFindAllByStatus } from '../Api/Transaction_Api'
import { useNavigate } from 'react-router-dom'
import { FaRegFile } from 'react-icons/fa'
import { getReportDataApi } from '../Api/CommonApi'
import TitleNavbar from '../Navbar/TitleNavbar'



const DailySaleSummery = () => {
 const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];

  const role = sessionStorage.getItem('role');
  const sessionYear = sessionStorage.getItem('sessionYear');
  const year = sessionYear;
  const navigate = useNavigate();
      useEffect(() => {
        if (!sessionYear) {
          sessionStorage.clear();
          navigate('/')
        }
      },[])
  
  const userId = sessionStorage.getItem('userId'); 
  const isAdmin = sessionStorage.getItem('role');   
  const branchId = sessionStorage.getItem('branchId');

console.log("Admin",isAdmin);

  const [errors, setErrors] = useState({
    toDate: "",
    mineName: "",
    fromDate: "",
    Type:"",
  });
  const [toDate, setToDate] = useState("");
  const [mineName, setMineName] = useState("");
  const [daily, setDaily] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [allMine, setAllMine] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
    const [pageSize, setPageSize] = useState(10);
            const [filteredData, setFilteredData] = useState([]);
            const [currentPage, setCurrentPage] = useState(1);
            const [totalEntries, setTotalEntries] = useState(0);
            const[viewButton,setViewButton]=useState(false);
            const[Type,setType]=useState("1");
            const[ID,setID]=useState("");
            const [loading, setLoading] = useState(false);
  
     //======Search data from table===============
     const handleSearch = (value) => {
      const filtered = daily.filter((item) =>
        Object.values(item).some((val) =>
          val?.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
    
      setFilteredData(filtered);
      setTotalEntries(filtered.length);
      setCurrentPage(1);
    };
    
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };
  
    const columns = [
      {
        title: "Sr.No.",
        dataIndex: "",
        key: "index",
        render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
      },
      {
        title: "Date",
        dataIndex: "billing_date",
        key: "billing_date",
      },
      {
        title: "Mine Name",
        dataIndex: "mine_name",
        key: "mine_name",
      },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        key: "customer_name",
      },
      {
        title: "Product Name",
        dataIndex: "product_name",
        key: "product_name",
      },
      {
        title: "Vehicle No.",
        dataIndex: "vehicle_no",
        key: "vehicle_no",
      },
      {
        title: "Bill No.",
        dataIndex: "sale_bill_no",
        key: "sale_bill_no",
      },
      {
        title: "Rate",
        dataIndex: "rate",
        key: "rate",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
      },
    
    
      {
          title: " Total Amount",
          dataIndex: "total_amount",
          key: "total_amount",
        },
    
     
    ];
  
    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "10px",
              fontSize: "13px",
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
            }}
          >
            {children}
          </td>
        ),
      },
    };

  useEffect(() => {
    fetchMineNames();
 
  }, []);


  let isError = false;


  const fetchMineNames = async () => {
  
    try {

      if (isAdmin==1) {
        const response = await axios.get(`${MineMasterFindAll}`);
        if (response.data !== null) {
          setAllMine(response.data);
        }
      }
      else {
        const response = await axios.get(`${MineMasterAssignedFindAll}?id=${userId}&branchId=${branchId}&accYear=${year}`);
        if (response.data !== null) {
          setAllMine(response.data);
        }
      }
     
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Mines:", error);
        toast.error("Failed to fetch Mines data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };


  const handleSubmit = async () => {
    let isValid = true;
    const errorObj = {};

    if (!toDate) {
      isValid = false;
      errorObj.toDate = "Date is required *";
    }
    if (!mineName) {
      isValid = false;
      errorObj.mineName = "Mine Name is required *";
    }
    if (!Type) {
      isValid = false;
      errorObj.Type = "Type is required *";
    }
    if (!fromDate) {
      isValid = false;
      errorObj.fromDate = "From date is required *";
    }

    setErrors(errorObj); // Set error messages

    if (!isValid) return;
    setLoading(true);

    const formattedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
         const formattedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';

try{
    const response = await axios.get(`${DailySaleSummaryReport}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&mineId=${mineName}&id=${ID}&reportId=${Type}&branchId=${branchId}&accYear=${year}`);
    console.log("Response data:", response);
    setLoading(false);
    let reportUrl = response.data;
    console.log("Response data:", response.data);
    if(reportUrl === "REPORT FILE NOT FOUND"){
          toast.warn('Report File Not Found...!!', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });}else {
      const reportLink =  getReportDataApi + `output/${reportUrl}`;
      window.open(reportLink, "_blank");
    }
  } catch (error) {
    setLoading(false);
    console.error("Error during API call:", error);
    toast.error("Error occurred while submitting data");
  }
  finally {
    setLoading(false); // Hide the loader
  }
  setErrors({});
   
  
  };
  

  const handleMineSelect = (value) => {
    setMineName(value); 
    if (value === "0") {
      setID(1); 
      setSelectAll(true);
     
    } else {
      setSelectAll(false);
      setID(2); 
    }
  };

    // ==============Get table data================
  
 const fetchDaily = async () => {
  let isValid = true;
      const errorObj = {};
  
      if (!toDate) {
        isValid = false;
        errorObj.toDate = "Date is required *";
      }
      if (!mineName) {
        isValid = false;
        errorObj.mineName = "Mine Name is required *";
      }
      if (!Type) {
        isValid = false;
        errorObj.Type = "Type is required *";
      }
      if (!fromDate) {
        isValid = false;
        errorObj.fromDate = "From date is required *";
      }
  
      setErrors(errorObj); // Set error messages
  
      if (!isValid) return;
 setLoading(true);

      const formattedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
      const formattedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';
  
    
  try {
    let url 
    // Construct the API URL with query parameters
  
    // if (selectAll) {
    //   // Call the new API for all mines when "All Mines" is selected
    //   url = `${AllDailySaleSummary}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&branchId=${branchId}&accYear=${year}`;
    // } else {
      
    //   url = `${DailySaleSummary}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&mineId=${mineName}&branchId=${branchId}&accYear=${year}`;
    // }
      url = `${DailySaleSummary}?fromDate=${formattedFromDate}&toDate=${formattedToDate}&mineId=${mineName}&id=${ID}&reportId=${Type}&branchId=${branchId}&accYear=${year}`;

    const response = await axios.get(url);
    
    // Check if the response data is valid
    if (response.data && Array.isArray(response.data)) {
      if (response.data.length > 0) {
        setDaily(response.data);
        setFilteredData(response.data);
        setTotalEntries(response.data.length); 
        setViewButton(true);
      } else {
        setDaily([]); // No data available, set empty
        setFilteredData([]); // Set empty filtered data
        console.log("No data available for the given date range and mines.");
        toast.success("No data available for the given date range and mines.");
      }
    } else {
      // Handle invalid data structure
      console.error('Invalid response data:', response.data);
      toast.error('Failed to fetch Billing Summary: Invalid data structure');
    }
  } catch (error) {
    console.error('Error fetching Billing Summary:', error);
    toast.error('Failed to fetch Billing Summary');
  }
  finally {
    setLoading(false); // Hide the loader
  }

  setErrors({});
    };
 

    
    const handleView = () => { 
  
      fetchDaily();
    };
    
    const handleDownloadPDF = () => {
      setType("1"); // Type for PDF download
      handleSubmit();
    };
    
    const handleDownloadExcel = () => {
      setType("2"); // Type for Excel download
      handleSubmit();
    };
      

       //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================
      
  return (
   <>
      <AdminNavbar /> 
       <div className="p-0 m-0">
    
            <div
              className="row m-0"
              style={navbg}
            >
              <div
                className="col-12 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                <span className="px-md-5"   style={{ flexGrow: 1 }}>
                {" "}
                  <AiOutlineFileText /> &nbsp; Bill Summary 
                </span>
                <span  >
            <TitleNavbar/>
            </span>
              </div> </div>
              <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

                  {/* <div className="col-12 pt-2 ">
                    <div className="row m-0">
                      <div classNastyle={{marginLeft:"600px", marginRight:"20px"}}me="col-3 p-0 lableStyle">
                        <label className="labels"> Type :</label>
                      </div>
                      <div className="col-9 col-lg-6">
                      <Select
                       value={Type || undefined}
                       onChange={(value) => setType(value)}
                           showSearch
                      className="w-100"
                     placeholder="Select Type"
                       optionFilterProp="children">
                                  <Select.Option value="1">
                                  Pdf
                                  </Select.Option>
                                  <Select.Option value="2">
                                   Excel
                                  </Select.Option>
                                 
                              </Select>
                             
                          {errors.Type && (
                            <div className="errorField">{errors.Type}</div>
                          )}
                      </div>
                    </div>
                  </div> */}

                <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>From Date: </label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <DatePicker
                        defaultValue={null}
                        value={fromDate}
                        onChange={(value) => setFromDate(value)}
                        className="w-100"
                        format={dateFormatList}
                      />
                        {errors.fromDate && (
                          <div className="errorField">{errors.fromDate}</div>
                        )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2 ">
                  <div className="row m-0">
                    <div className="col-3 p-0 lableStyle">
                      <label className="labels"  style={{fontSize:16}}>To Date: </label>
                    </div>
                    <div className="col-9 col-lg-6">
                    <DatePicker
                        defaultValue={null}
                        value={toDate}
                        onChange={(value) => setToDate(value)}
                        className="w-100"
                        format={dateFormatList}
                      />
                        {errors.toDate && (
                          <div className="errorField">{errors.toDate}</div>
                        )}
                    </div>
                  </div>
                </div>

                <div className="col-12 pt-2">
      <div className="row m-1">
        <div className="col-3 p-0 lableStyle">
          <label className="labels"  style={{fontSize:16}}>Mine Wise: </label>
        </div>
        <div className="col-9 col-lg-6">
        {isAdmin == 1 && (
              <Select
        value={selectAll ? 'All Mines' : mineName || undefined}
      onChange={handleMineSelect}
      className="w-100"
      placeholder="Select Mine"
    >
      <Option value="0">All Mines</Option>
      {allMine.map((mine) => (
        <Option key={mine.id} value={mine.id}>
          {mine.mineName}
        </Option>
      ))}
    </Select>
  )}
{(userId && isAdmin!=1 )&&(
  <Select
           value={ mineName || undefined}
           onChange={handleMineSelect}
      className="w-100"
      placeholder="Select Mine"
    >
    
      {allMine.map((mine) => (
        <Option key={mine.mineId} value={mine.mineId}>
          {mine.mineName}
        </Option>
      ))}
    </Select>
)}

          </div>

          {errors.mineName && <div className="errorField">{errors.mineName}</div>}
        </div>
      </div>          
      
                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleView}
                    disabled={loading}
                  >
                    {loading ? <Spin size="small" /> : 'View'} 
                  </Button>
                  
                 
                </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: "2px solid #bfb597" }}
                ></div>
              </div>
          </div>
          <div className='col-12 col-md-2 col-lg-4'></div>
        </div>
        {/*================ Table =========================*/}
         {viewButton&&(   <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
                 <div className='col-12 col-md-2'></div>
                   <div  className="col-12 col-md-8 py-3 shadow border"
                     style={{ marginBottom: "50px", backgroundColor: "white" }}
                   >
                     <div
                       className="col-12 px-md-5"
                       style={{ display: "flex", justifyContent: "space-between" }}
                     >
                       <div>
                         <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                         <Select
                           defaultValue={pageSize}
                           onChange={handlePageSizeChange}
                           style={{ width: 120, textAlign: "center" }}
                         >
                           <Option value={10}>10</Option>
                           <Option value={20}>20</Option>
                           <Option value={30}>30</Option>
                         </Select>
                       </div>
                       <div className="pt-4 pt-md-0" style={{ display: "flex", gap: "10px" }}>
                       <Tooltip title="Download PDF" placement="top">
        <div
       
          style={{
            cursor: 'pointer', 
            fontSize: '24px', 
            color: '#D32F2F',
            marginBottom: 16
          }}
          onClick={handleDownloadPDF}
          disabled={loading}
        >
          <AiFillFilePdf />
        </div>
      </Tooltip>
                   
     
                       <Tooltip title="Download Excel" placement="top">
        <div
       
          style={{
            cursor: 'pointer', 
            fontSize: '24px', 
            color: 'green',
            marginBottom: 16
          }}
          onClick={handleDownloadExcel}
          disabled={loading}
        >
          <AiFillFileExcel />
        </div>
      </Tooltip>
                      
                         <Input.Search
                           placeholder="Search"
                           onSearch={handleSearch}
                           style={{ width: 200, marginBottom: 16 }}
                         />
                       </div>
                     </div>
         
                     <div style={{ backgroundColor: "white" }}>
                       <Table
                         bordered
                         style={{ padding: "0px 20px", overflowX: "auto" }}
                          columns={columns}
                         dataSource={filteredData}
                         pagination={{
                           pageSize: pageSize,
                           total: totalEntries,
                           showTotal: (total, range) =>
                             `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                           current: currentPage,
                           onChange: (page) => setCurrentPage(page),
                         }}
                         showSorterTooltip={false}
                         rowKey={(record) => record.id}
                          components={components}
                       />
                     </div>
                   </div>
                   <div className='col-12 col-md-2'></div>
                 </div>)} 
               
    </div>
  </>
  )
}

export default DailySaleSummery